module.exports = __webpack_public_path__ + "static/media/lineofsight.a6b31e40.frag";